import React, { useState, useEffect } from "react";
import "./App.css";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import Header3 from "./components/Header3";
import ClipLoader from "react-spinners/ClipLoader";

function Smsmarketingsuccessful(props) {
  useEffect(() => {
    const textid = localStorage.getItem("textid");
    const businessid = localStorage.getItem("businessid");
    const audience = localStorage.getItem("audience");

    document.title = "Successful";
    // const baseURL = 'https://karamale.com/apps/kscanner/webservices.php?query=NOTIFY-URL-SMS-MARKETING&business_id='+businessid+'&textid='+textid+'&audience='+audience;
    //     Axios.get(baseURL)
  }, []);

  return (
    <div className="view">
      <Header3 />

      <div className="container">
        <div className="row justify-content-center just-container-insid">
          <div className="col-lg-7 mt-5 pl-0 pr-0">
            <div className=" BoxDashboardContainer mb-5 pl-1 pr-1">
              <div className="row align-self-center justify-content-center">
                <div className="text-left col-12 mt-1">
                  <h5>✅ Payment Successful</h5>
                </div>
                <div className="h-divider w-100 mt-2"></div>
                <div className="col-12 text-left p-0">
                  <div className="w-100">
                    <div className="col-12">
                      <label className="font-normal w-100">
                        <p>
                          Your payment was successful. Your SMS messages have
                          been queued and will be delivered shortly. — no need
                          to do anything else!
                        </p>
                        <p>
                          <b>Status:</b> In queue for delivery
                        </p>
                        <p>
                          Thank you for choosing <span>Karamale</span> to
                          connect with your audience!
                        </p>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Smsmarketingsuccessful;
